import React, { useState, useEffect } from 'react';
import { Formik, Form as FormMik } from 'formik';
import { Form, Button, Image } from 'react-bootstrap';
import * as Yup from 'yup';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '../hooks/toast';

import ConfigPage from './Config';
import ConfigMessage from './ConfigMessage';
import ConfigAppearance from './ConfigAppearance';
import ConfigLog from './ConfigLog';
import About from './About';
import ConfigTerms from './ConfigTerms';

import api from '../services/apiClient';

import ConfigIcon from '../assets/icon/opcoesB.svg';
import ArrowRightIcon from '../assets/icon/arrowRight.svg';
import AparenciaIcon from '../assets/icon/aparencia.svg';
import LogIcon from '../assets/icon/log.svg';
import SobreIcon from '../assets/icon/sobre.svg';
import ConversaIcon from '../assets/icon/mensagemBold.svg';

const enumConfig = {
  Config: 0,
  ConfigMensagem: 1,
  ConfigAparencia: 2,
  ConfigTermo: 3,
  ConfigLog: 4,
  About: 5,
};

const Parameter: React.FC<any> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showPage, setShowPage] = useState(enumConfig.Config);
  const [itemSelected, setItemSelected] = useState(false);
  const [showGridParametros, setShowGridParametros] = useState(true);

  const loadPage = (option: number): any => {
    if (option === enumConfig.Config) {
      return <ConfigPage />;
    }
    if (option === enumConfig.ConfigMensagem) {
      return <ConfigMessage />;
    }
    if (option === enumConfig.ConfigAparencia) {
      return <ConfigAppearance />;
    }
    if (option === enumConfig.ConfigTermo) {
      return <ConfigTerms />;
    }
    if (option === enumConfig.ConfigLog) {
      return <ConfigLog />;
    }
    if (option === enumConfig.About) {
      return <About />;
    }

    return <ConfigPage />;
  };

  useEffect(() => {
    const maximizeLog = searchParams.get('maximizeLog') === 'true';

    setShowGridParametros(!maximizeLog);
  }, [searchParams]);

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('maximizeLog'); // Remove o parâmetro desejado
    setSearchParams(newParams); // Atualiza a URL com os novos parâmetros
  }, []);

  return (
    <div className={`d-flex me-2 ${showGridParametros ? 'ms-2' : 'ms-1'}`}>
      {showGridParametros && (
        <section
          className="col-5 overflow-hidden div-selected-hover"
          style={{
            borderRadius: '0.68rem',
            height: 'Calc(100vh - 16rem)',
            boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
          }}
        >
          <div
            className="w-100"
            style={{
              backgroundColor: '#1A1A1A',
            }}
          >
            <span
              className="text-white ms-1"
              style={{
                fontSize: '1.68rem',
                fontWeight: '600',
                backgroundColor: '#1A1A1A',
              }}
            >
              Parâmetros
            </span>
          </div>
          <div
            className="d-flex w-100 ps-2 position-relative"
            role="button"
            tabIndex={0}
            onKeyPress={() => {
              setShowPage(enumConfig.ConfigTermo);
              setItemSelected(true);
            }}
            onClick={() => {
              setShowPage(enumConfig.ConfigTermo);
              setItemSelected(true);
            }}
          >
            <Image src={ConversaIcon} alt="Termo e Condições" />
            <div className="d-flex flex-column ms-2">
              <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                Termo e Condições
              </span>
              <span
                style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#818181',
                }}
              >
                Texto legal exibido ao cliente na entrada do chat
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-end me-3"
              style={{ flexGrow: 1 }}
            >
              <Image
                src={ArrowRightIcon}
                style={{ width: '0.75rem', height: '1.18rem' }}
                alt="Termo e Condições"
              />
            </div>
          </div>
          <div
            className="d-flex w-100 ps-2 position-relative"
            role="button"
            tabIndex={0}
            onKeyPress={() => {
              setShowPage(enumConfig.Config);
              setItemSelected(true);
            }}
            onClick={() => {
              setShowPage(enumConfig.Config);
              setItemSelected(true);
            }}
          >
            <Image src={ConfigIcon} alt="Configurações" />
            <div className="d-flex flex-column ms-2">
              <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                Configurações gerais
              </span>
              <span
                style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#818181',
                }}
              >
                Tempo de atendimento • Chat • Notificação{' '}
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-end me-3"
              style={{ flexGrow: 1 }}
            >
              <Image
                src={ArrowRightIcon}
                style={{ width: '0.75rem', height: '1.18rem' }}
                alt="Configurações"
              />
            </div>
          </div>

          <div className="d-flex w-100 ps-2 position-relative">
            <Image src={ConversaIcon} alt="Configurações" />
            <div
              className="d-flex flex-column ms-2"
              role="button"
              tabIndex={0}
              onKeyPress={() => {
                setShowPage(enumConfig.ConfigMensagem);
                setItemSelected(true);
              }}
              onClick={() => {
                setShowPage(enumConfig.ConfigMensagem);
                setItemSelected(true);
              }}
            >
              <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                Mensagens padronizadas
              </span>
              <span
                style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#818181',
                }}
              >
                Criação de mensagens padrões personalizadas
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-end me-3"
              style={{ flexGrow: 1 }}
            >
              <Image
                src={ArrowRightIcon}
                style={{ width: '0.75rem', height: '1.18rem' }}
                alt="Configurações"
              />
            </div>
          </div>
          <div
            className="d-flex w-100 ps-2 position-relative"
            role="button"
            tabIndex={0}
            onKeyPress={() => {
              setShowPage(enumConfig.ConfigAparencia);
              setItemSelected(true);
            }}
            onClick={() => {
              setShowPage(enumConfig.ConfigAparencia);
              setItemSelected(true);
            }}
          >
            <Image src={AparenciaIcon} alt="Aparência" />
            <div className="d-flex flex-column ms-2">
              <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                Aparência
              </span>
              <span
                style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#818181',
                }}
              >
                Plano de fundo • Cor principal • Logotipo
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-end me-3"
              style={{ flexGrow: 1 }}
            >
              <Image
                src={ArrowRightIcon}
                style={{ width: '0.75rem', height: '1.18rem' }}
                alt="Configurações"
              />
            </div>
          </div>
          <div
            className="d-flex w-100 ps-2 position-relative"
            role="button"
            tabIndex={0}
            onKeyPress={() => {
              setShowPage(enumConfig.ConfigLog);
              setItemSelected(true);
            }}
            onClick={() => {
              setShowPage(enumConfig.ConfigLog);
              setItemSelected(true);
            }}
          >
            <Image src={LogIcon} alt="Configurações" />
            <div className="d-flex flex-column ms-2">
              <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                Log
              </span>
              <span
                style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  color: '#818181',
                }}
              >
                Verificação de log do sistema
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-end me-3"
              style={{ flexGrow: 1 }}
            >
              <Image
                src={ArrowRightIcon}
                style={{ width: '0.75rem', height: '1.18rem' }}
                alt="Configurações"
              />
            </div>
          </div>
          <div
            className="d-flex align-items-center w-100 ps-2 mt-1"
            role="button"
            tabIndex={0}
            onKeyPress={() => {
              setShowPage(enumConfig.About);
              setItemSelected(true);
            }}
            onClick={() => {
              setShowPage(enumConfig.About);
              setItemSelected(true);
            }}
          >
            <Image src={SobreIcon} alt="Configurações" />
            <div className="ms-2" style={{ flexGrow: 1 }}>
              <span style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                Sobre
              </span>
            </div>
            <div
              className="d-flex align-items-center justify-content-end me-3"
              style={{ flexGrow: 1 }}
            >
              <Image
                src={ArrowRightIcon}
                style={{ width: '0.75rem', height: '1.18rem' }}
                alt="Configurações"
              />
            </div>
          </div>
        </section>
      )}
      <section
        className={`w-100 overflow-hidden ${showGridParametros ? 'ms-3' : ''}`}
        style={{
          borderRadius: '0.68rem',
          height: 'Calc(100vh - 16rem)',
          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
          opacity: `${itemSelected ? '1' : '0.5'}`,
          pointerEvents: `${itemSelected ? 'auto' : 'none'}`,
        }}
      >
        {loadPage(showPage)}
      </section>
    </div>
  );
};

export default Parameter;
